import React from "react";

function ExternalLink({ href, children, download, className }) {
  if (download) {
    return (
      <a className={className} href={href} download={download}>
        {children}
      </a>
    );
  }

  return (
    <a className={className} href={href} target="_blank" rel="noopener noreferrer">
      {children}
      <span className="sr-only"> (opens in a new tab)</span>
    </a>
  );
}

export default ExternalLink;
